import { useState } from "react";
import FilterListOffRoundedIcon from '@mui/icons-material/FilterListOffRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';

interface Props {
    children: React.ReactNode;
    width?: string;
}

export function FilterContainer({ children, width }: Props) {
    const [showFilters, setShowFilters] = useState<boolean>(false);

    return (
        <div className="flex justify-end w-full relative transition-all duration-100 h-auto">
            <div className={`${showFilters ? "" : "hidden"} ${width} mx-3`}>
                { children }
            </div>
            <div 
                className="flex items-start cursor-pointer z-10 "
                onClick={() => setShowFilters(!showFilters)}>
                {showFilters 
                ? <FilterListOffRoundedIcon />
                : <FilterListRoundedIcon />}
            </div>
        </div>
    );
}